/**
 * Tiny inline SVG sparkline. Pure render — no external chart deps.
 * Used in BOM Cost report (cost / SP / margin trends) and Vendor
 * Price Comparison (last-12-invoice trend per RM).
 */
import React from "react";

export function Sparkline({
  values,
  w = 90,
  h = 24,
  stalePoints = [],
  type = "neutral",
}) {
  if (!values?.length) return <span className="text-zinc-400 text-[10px]">—</span>;
  const numeric = values.map((v) => (v == null ? null : Number(v)));
  const validPts = numeric.filter((v) => v != null && !Number.isNaN(v));
  if (validPts.length < 2)
    return <span className="text-zinc-400 text-[10px]">—</span>;

  const min = Math.min(...validPts);
  const max = Math.max(...validPts);
  const range = max - min || 1;
  const pts = numeric.map((v, i) => {
    const x = (i / (numeric.length - 1)) * w;
    if (v == null || Number.isNaN(v)) return null;
    const y = h - ((v - min) / range) * h;
    return [x, y, v];
  });
  const validPathPts = pts.filter(Boolean).map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const last = validPts[validPts.length - 1];
  const first = validPts[0];
  const up = last >= first;
  const palette = {
    cost: up ? "#b91c1c" : "#0f766e",
    sp: up ? "#0f766e" : "#b91c1c",
    margin: up ? "#0f766e" : "#b91c1c",
    neutral: up ? "#0f766e" : "#b91c1c",
  };
  const stroke = palette[type] || palette.neutral;
  return (
    <svg width={w} height={h} className="overflow-visible" data-testid={`sparkline-${type}`}>
      <polyline fill="none" stroke={stroke} strokeWidth="1.5" points={validPathPts} />
      {pts.map((p, i) => {
        if (!p) return null;
        const [x, y] = p;
        if (i === pts.length - 1) {
          return <circle key={i} cx={x} cy={y} r="2.2" fill={stroke} />;
        }
        if (stalePoints[i]) {
          return <circle key={i} cx={x} cy={y} r="1.2" fill="#f59e0b" opacity="0.7" />;
        }
        return null;
      })}
    </svg>
  );
}

export default Sparkline;
